import { GalleryItem } from '../interfaces';

export const GALLERY_ITEMS: GalleryItem[] = [
    {
        id: '1',
        name: 'Peppa Flame Intro Video',
        type: 'video' as const,
        thumbnail: 'https://picsum.photos/id/1/200/200',
        size: '12.5 MB',
        duration: '00:30',
        dateCreated: 'August 21, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '2',
        name: 'Weekly Special Menu',
        type: 'image' as const,
        thumbnail: 'https://picsum.photos/id/2/200/200',
        size: '2.1 MB',
        dateCreated: 'August 22, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '3',
        name: 'Live Music Event Poster',
        type: 'image' as const,
        thumbnail: 'https://picsum.photos/id/3/200/200',
        size: '1.8 MB',
        dateCreated: 'August 23, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '4',
        name: 'Chef Interview',
        type: 'video' as const,
        thumbnail: 'https://picsum.photos/id/4/200/200',
        size: '45.0 MB',
        duration: '02:15',
        dateCreated: 'August 24, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '5',
        name: 'Dining Area Panorama',
        type: 'image' as const,
        thumbnail: 'https://picsum.photos/id/5/200/200',
        size: '3.5 MB',
        dateCreated: 'August 25, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '6',
        name: 'Cocktail Making Demo',
        type: 'video' as const,
        thumbnail: 'https://picsum.photos/id/6/200/200',
        size: '28.2 MB',
        duration: '01:45',
        dateCreated: 'August 26, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '7',
        name: 'Customer Testimonials',
        type: 'video' as const,
        thumbnail: 'https://picsum.photos/id/7/200/200',
        size: '33.1 MB',
        duration: '03:20',
        dateCreated: 'August 27, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '8',
        name: 'New Year Eve Bash',
        type: 'image' as const,
        thumbnail: 'https://picsum.photos/id/8/200/200',
        size: '2.9 MB',
        dateCreated: 'August 28, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '9',
        name: 'Kitchen Behind the Scenes',
        type: 'video' as const,
        thumbnail: 'https://picsum.photos/id/9/200/200',
        size: '19.8 MB',
        duration: '01:10',
        dateCreated: 'August 29, 2025',
        uploadedBy: 'Joemar Admin',
    },
    {
        id: '10',
        name: 'Festive Season Offer',
        type: 'image' as const,
        thumbnail: 'https://picsum.photos/id/10/200/200',
        size: '2.4 MB',
        dateCreated: 'August 30, 2025',
        uploadedBy: 'Joemar Admin',
    },
];
